import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./newStyleTheme.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import store from "./store/store";
import { Provider } from "react-redux";
import { AnimatePresence } from "framer-motion";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import "./Translation/i18n-translation-config";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <AnimatePresence>
          <App />
        </AnimatePresence>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);
